import { ISaveAddressPayload, IStateAutocomplete } from 'addresses/types';

import { IUpsertAddressForm } from './types';

export const mapUpsertAddressForm = (data: IUpsertAddressForm): ISaveAddressPayload => {
  const { address } = data;
  const state = address?.state;

  return {
    address: {
      name: address?.name,
      line1: address?.line1,
      line2: address?.line2,
      city: address?.city,
      state: (state as IStateAutocomplete)?.id?.toString() || (state as string),
      country: address?.country?.abbreviation,
      zip: address?.zip,
      contactName: data?.contactName,
      contactPhone: data?.contactPhone,
      contactEmail: data?.contactEmail,
      contactCompanyName: data?.contactCompanyName,
    },
  };
};
